import { Component, OnInit, ViewChild, Output, EventEmitter, Input, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatSnackBar, MatTableDataSource, MatPaginator, MatSort, MatSidenav } from '@angular/material';
import { AddCompModalComponent } from './add-comp-modal/add-comp-modal.component';
// import { EditCompModalComponent } from './edit-comp-modal/edit-comp-modal.component'
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { ActivatedRoute } from '@angular/router';
import { CompetenciesService } from 'src/app/services/competencies.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { config } from '../../_models/userCompetency'
import * as _ from 'lodash';
import { SharedService } from 'src/app/shared.service';
import { FilterService } from '../../services/filter.service'
import { UtilityService } from '../../services/utility.service'
import { AssetService } from '../../services/asset.service'
import { EditCompModalComponent } from 'src/app/competency/edit-comp-modal/edit-comp-modal.component';

@Component({
  selector: 'app-competences',
  templateUrl: './competences.component.html',
  styleUrls: ['./competences.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})
export class CompetencesComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  displayedColumns = ['alias', 'title', 'achievementDate', 'recertificationDate', 'status', 'action']
  pageSizeOptions: number[] = [25, 50, 100];
  compArray: any = [];
  compCopy: any = [];
  instructorId;
  expandedElement;
  allFiles: any;
  file: any;
  currentUser: any;
  hideActions: boolean;
  currentInnerIndex: any;
  currentOuterIndex: any = -1;
  jobs;
  displayCompentency
  systemDate
  searchText
  // isDetailsModel:boolean
  // filterActive;
  noDataMsg = {
    title: "No Competencies!",
    data: "You have not yet added any competencies"
  }
  filterActive: boolean = false
  afterFilter
  tempDataSource: any;
  category = config.list
  selectedCat: any;
  loading: boolean = false;
  viewDelete: boolean = false;
  noFiles = {
    title: "No Files!",
    data: "No files added yet!"
  }
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('expandedDetail');
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  @Input('displayCompentencies') displayCompentencies;
  @Input('deletedId') deletedId;
  @Input('newComp') newCompAdded: any;
  @Input('isDetailsModel') isDetailsModel: Boolean
  @Input('competenciesData') competenciesData
  @Input('systemDate') systemDateModel
  @Output() openSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    public _filter: FilterService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    public _snackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    public _competencyService: CompetenciesService,
    private _sharedService: SharedService,
    public _utilityService: UtilityService,
    public _assetService: AssetService
  ) {
    this.dataSource = new MatTableDataSource(this.compArray)

    // this._competencyService.deleteCompetenciesObservable().subscribe((data) => {
    //   let deleteCompObj = data.newComp
    //   console.log("Delete Competency Observable .....", deleteCompObj)
    //   let index = _.findIndex(this.compArray, function (o) { return o._id == deleteCompObj._id })
    //   if (index > -1) {
    //     // this.compArray.splice(index, 1)
    //     // this.closeFilesSideNav.emit('close')
    //     // this._utilityService.handleSnackBar({ msg: "Competencies Delete successfully!", button: "OK" })
    //     // this.updateData(this.compArray)
    //     // this.cd.detectChanges()
    //   }
    // })

  }

  ngOnInit() {
    //  this.compArray=this.instructorCompetency
    // if (!this.isDetailsModel) {
    //   this._sharedService.sharedCompetency.subscribe(sharedComp => {
    //     console.log("in subscribe");
    //     this.newCompAdded = sharedComp
    //     console.log("***sharedComp", this.newCompAdded);

    //     this.newCompAdded.competency['isValid'] = ((new Date(this.newCompAdded.competency.expiryDate) < new Date()) == false) ? true : false
    //     if (this.newCompAdded.isEdit) {
    //       for (let i = 0; i < this.compArray.length; i++) {
    //         if (this.compArray[i]._id == this.newCompAdded.competency._id) {
    //           this.compArray[i] = this.newCompAdded.competency
    //         }
    //       }
    //       console.log("item=========>", this.compArray);
    //       this.updateData(this.compArray)
    //     }
    //     else {
    //       this.compArray.push(this.newCompAdded.competency)
    //       console.log("i will overwrite the value anyway!!!")
    //       if (sharedComp.competency.category != "Init") {
    //         this.currentOuterIndex = this.compArray.length - 1
    //       }
    //       this.closeFilesSideNav.emit()

    //       console.log("After condition", this.compArray);
    //       this.compCopy = this.compArray;
    //       this.updateData(this.compArray)
    //     }
    //   })
    //   this._sharedService.sharedFolder.subscribe(res => {
    //     console.log("Competency delete response in comp ", res)
    //     this.closeFilesSideNav.emit('close')
    //     let index = _.findIndex(this.compArray, function (o) { return o._id == res.fileId })
    //     if (index > -1) {
    //       this.compArray.splice(index, 1)
    //     }
    //   })
    //   this.loading = true;
    //   this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    //   if (this.currentUser && this.currentUser.userRole == 'admin') {
    //     this.viewDelete = true;
    //   }

    //   if (this.currentUser.userRole == 'client') {
    //     this.displayedColumns = ['title', 'xDate', 'valid', 'attachment']
    //     this.hideActions = true
    //   }


    this.activatedRoute.params.subscribe(params => {
      this.instructorId = params['id'];
      console.log("this.instructorId =  ", this.instructorId);
      if (this.instructorId) this.getCompetencyData()
    });
    // }
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("***changes", changes);
    if (changes.displayCompentencies && changes.displayCompentencies.currentValue) {
      this.displayCompentency = changes.displayCompentencies.currentValue;
    }
    if (changes.deletedId && changes.deletedId.currentValue) {
      this.loading = true
      this.deletedId = changes.deletedId.currentValue
      let tempdeletedId = this.deletedId
      console.log("*****this.deletedId", this.deletedId);
      let compIndex = _.findIndex(this.compArray, function (o) { return o._id == tempdeletedId.competenciesId })
      if (compIndex > -1) {
        let fileIndex = _.findIndex(this.compArray[compIndex].files, function (o) { return o._id == tempdeletedId.fileId })
        if (fileIndex > -1) {
          this.compArray[compIndex].files.splice(fileIndex, 1)
          this.updateData(this.compArray)
        }
      }
    }

    if (changes.competenciesData && changes.competenciesData.currentValue) {
      console.log("here is the data comp ", changes.competenciesData.currentValue)
      this.compArray = changes.competenciesData.currentValue
      // //  this.compArray = res.competencies
      this.updateData(this.compArray)
      //  this.isDetailsModel=true
      this.loading = false


    }

    if (changes.systemDateModel && changes.systemDateModel.currentValue) {
      console.log("here is the data comp Date", changes.systemDateModel.currentValue)
      this.systemDate = changes.systemDateModel.currentValue
      // //  this.compArray = res.competencies
      // this.updateData(this.compArray)
      //  this.isDetailsModel=true
      this.loading = false


    }



  }


  addCompModal() {
    this._assetService.closeDisplayFile(true)
    this.closeFilesSideNav.emit('close')
    console.log("Open modal");
    let data = {
      instructorId: this.instructorId
    }
    this._utilityService.commonDialogBoxOpen(AddCompModalComponent, data, 900).afterClosed().subscribe(data => {
      // console.log("Data in comp", data.isEdit);
      if (data == undefined) return
      else {
        this.compArray = data.competencies
        this.systemDate = data.dateSystem
        console.log("***this.compArray", this.compArray);
        this.compCopy = this.compArray;
        this.updateData(this.compArray)
      }
      //  else if (data.isEdit == true) {
      //   for (let i = 0; i < this.compArray.length; i++) {
      //     if (this.compArray[i]._id == data.competency._id) {
      //       this.compArray[i] = data.competency
      //     }
      //   }
      //   console.log("item=========>", this.compArray);
      //   this.updateData(this.compArray)
      // }
      // else {
      //   this.compArray.push(data)
      //   this.updateData(this.compArray)
      // }
    })
  }

  editCompetency(item) {
    this._assetService.closeDisplayFile(true)
    let data = {
      instructorId: this.instructorId,
      competency: item,
      isEdit: true
    }
    this._utilityService.commonDialogBoxOpen(AddCompModalComponent, data, 900).afterClosed().subscribe(data => {
      console.log("Data in comp", data);
      if (data == undefined) return
      else {
        this.compArray = data.competencies
        this.systemDate = data.dateSystem
        console.log("***this.compArray", this.compArray);
        this.compCopy = this.compArray;
        this.updateData(this.compArray)

        // for (let i = 0; i < this.compArray.length; i++) {
        //   if (this.compArray[i]._id == data.competency._id) {
        //     this.compArray[i] = data.competency
        //   }
        // }
        // console.log("item=========>", this.compArray);
        // this.updateData(this.compArray)
      }
    })
  }
  openFileUpload(element, i) {
    console.log("element in file upload", element, i);
    this.openDialog(NewFileModalComponent, { competenciesId: element._id }).subscribe(uploaded => {
      console.log("uploaded", uploaded);
      let tempArray = this.compArray

      if (uploaded && uploaded[0] && uploaded[0].data) {
        let index = _.findIndex(tempArray, function (o) { return o._id == element._id })
        if (index > -1) {
          this.compArray[index].files.push(uploaded[0].data.file)
          this.updateData(this.compArray)
        }
      }
    })
  }

  updateData(comp) {
    console.log("UPDATING DATA  for competency= ", comp)
    let tempArray = []
    tempArray = comp
    // for (let i = 0; i < comp.length; i++) {
    //   if (comp[i].alias != null) {
    //     tempArray[i].alias = comp[i].alias;
    //   } else {
    //     tempArray[i].alias = "";
    //   }
    // }
    this.dataSource = new MatTableDataSource(tempArray);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false;
  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log('OPENDIALOG', 'DATA = ', data)
    const dialogRef = this.dialog.open(someComponent, { data, width: '600', height: '967px' });

    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  expand(element) {
    console.log("***element", element)
    this.expandedElement = element
    this.allFiles = element.files
  }
  fileDetails(event) {
    console.log("event file tile clicked", event);
    console.log("this.expandedElement = element", this.expandedElement);
    this._assetService.displayFile(event)
    // this.file = event.file
    // this.openSideNav.emit({ compId: this.expandedElement._id, file: event, })
  }
  editCompModal(element) {
    this.openDialog(EditCompModalComponent, element).subscribe(data => {
      console.log("DATA IN COMP FROM EDIT", data)
      this.getCompetencyData();
    })

  }
  delete(element, outerIndex, innerIndex) {
    console.log("element on delete", element);
    this.openDialog(DeleteConfirmModalComponent, element).subscribe(confirm => {
      if (confirm == 'no') return
      else {
        console.log("element on delete", element, outerIndex, innerIndex);
        this._competencyService.deleteCompetency(element.competenciesId).subscribe(res => {
          console.log("Competency deleted====>>>", res);
          // this.getCompetencyData();
          this.compArray[outerIndex].competencies.splice(innerIndex, 1)
          // this.updateData(this.compArray)
        })
      }
    })
  }
  deletedFile(event) {
    console.log("**********file deleted event in competencies", event)
  }

  filter(searchText) {
    this.afterFilter = null
    this.filterActive = false;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.updateData(this.compArray);
      return;
    }
    console.log("filter Time pass data..", this.compArray)
    let data = this.compArray
    this.tempDataSource = this._filter.filter1(searchText, data, ['title', 'alias']);
    this.updateData(this.tempDataSource)
    console.log("tempDataSource-->", this.tempDataSource, this.loading, this.filterActive);
    if (this.tempDataSource.length <= 0) {
      this.filterActive = true;
      this.afterFilter = {
        title: "No Competencies!",
        data: "Sorry, no competencies matched your search"
      }
    }
  }



  weekHighlights(item) {

    // console.log("here is the item data ===>",this.systemDate )
    let achievementDate = this.systemDate
    let expiryDate = new Date(item.expiryDate)
    const week = 7 * 24 * 60 * 60 * 1000;
    let weeks = Math.ceil((<any>this.startOfWeek(new Date(expiryDate)) - <any>this.startOfWeek(new Date(achievementDate))) / week)
    // console.log("here is number of weeks ==>",weeks)

    // if (item.category == 'others') {
    //   return 'normal'
    // }
    // else 
    if (12 >= weeks) {
      return 'heightLight-text'
    }
    else {
      return 'normal'
    }


  }
  weekHighlightstr(item) {

    // console.log("here is the item data ===>",this.systemDate )
    let achievementDate = this.systemDate
    let expiryDate = new Date(item.expiryDate)
    const week = 7 * 24 * 60 * 60 * 1000;
    let weeks = Math.ceil((<any>this.startOfWeek(new Date(expiryDate)) - <any>this.startOfWeek(new Date(achievementDate))) / week)
    // console.log("here is number of weeks ==>",weeks)

    // if (item.category == 'others') {
    //   return 'normal'
    // }
    // else 
    if (12 >= weeks) {
      return 'heightLight-tr'
    }
    else {
      return 'normal'
    }


  }

  competencesStatusDisplay(data) {
    if (data.competenciesType && data.competenciesType.length && data.competenciesType[data.competenciesType.length - 1].status == 'P') {
      return data.competenciesType[data.competenciesType.length - 1].status
    }
    else {
      return ''
    }
  }

  statusValidation(data) {
    // if(data.competenciesType && (!data.competenciesType.length || data.competenciesType.length && data.competenciesType[data.competenciesType.length-1].status !='AP'  ) ){
    //   return 'd-none'
    //   }

  }

  startOfWeek(dt) {
    // console.log("here is the item extra function work===>")

    const day = 24 * 60 * 60 * 1000;
    const weekday = dt.getDay();
    return new Date(dt.getTime() - Math.abs(0 - weekday) * day);
  }

  selectCategory(event) {
    console.log("event when it is selected", event);

    let array1 = []
    let array2 = event.value
    console.log("this.selectedCat", this.selectedCat);

    if (array2 && array2.length) {
      array1 = this.compArray.filter(function (item) {
        return array2.includes(item.category);
      })
    }

    if (!array2.length) {
      this.updateData(this.compArray);
      this.filterActive = false
      this.afterFilter = null
      return;
    }

    console.log('selected type for filter.................', array1)
    if (array1.length <= 0) {
      this.filterActive = true
      this.afterFilter = {
        title: "No Competencies!",
        data: "Sorry, no competencies matched your selected category"
      }
    } else {
      this.filterActive = false
      this.afterFilter = null
    }
    this.updateData(array1)

  }


  // API
  getCompetencyData() {
    console.log('getCompetencyData Calling');
    this._competencyService.getCompetencies(this.instructorId).subscribe(res => {
      console.log("***res in comp = ", res.competencies);
      this.compArray = res.competencies
      this.systemDate = res.dateSystem
      console.log("***this.compArray", this.compArray);
      this.compCopy = this.compArray;
      this.updateData(this.compArray)
      this.loading = false;
    })
  }

  compDetails(data, outerIndex, innerIndex) {
    console.log('Comp Details====>', data, outerIndex, innerIndex);
    this.currentOuterIndex = outerIndex;
    this.currentInnerIndex = innerIndex
    data['isCompetencies'] = true;
    data['instructorId'] = this.instructorId;
    this.openSideNav.emit({ competency: data, compIndex: this.currentOuterIndex })
  }

  newComp() {
    console.log("New comp clicked");

    this.currentOuterIndex = -1;
    let data = {
      title: '',
      category: '',
      expiryDate: '',
      achievementDate: '',
      trainingBook: '',
      bookedDate: '',
      bookedBy: '',
      isCompetencies: true,
      files: [],
      instructorId: this.instructorId
    }
    this.openSideNav.emit({ competency: data })
    console.log("event emitted with data", data);
  }

  catChanged(event) {

    console.log('Category Changed===>', event.value);

    console.log('this.compCopy====>', this.compCopy);


    if (!event.value.length) {
      this.compArray = this.compCopy;
    } else {
      let filterArray = [];
      this.compCopy.forEach((e1) => event.value.forEach((e2) => {
        if (e1.category == e2) {
          filterArray.push(e1)
        }
      }));
      this.compArray = filterArray;
    }
  }

  sortChanged(event) {
    console.log('Sort Changed===>', event.value);

    console.log('this.compArray In sort', this.compArray);

    if (event.value.type == 'asc') {
      this.compArray = sort_by_key(this.compArray, event.value.key);
    } else if (event.value.type == 'desc') {
      let tempArray = sort_by_key(this.compArray, event.value.key);
      this.compArray = tempArray.reverse();
    }

    function sort_by_key(array, key) {
      return array.sort(function (a, b) {
        let x = a[key]; let y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
    }
  }





  deleteFile(event) {
    console.log('delete Event:', event);
  }
  getRandomColorClass(i) {

    return this._utilityService.getCommonRandomColorClass(i)
    console.log("what is temp", i);
    // return temp
  }
}
